import { render, staticRenderFns } from "./CMSInfomationForm.vue?vue&type=template&id=202e2238&scoped=true"
import script from "./CMSInfomationForm.vue?vue&type=script&lang=js"
export * from "./CMSInfomationForm.vue?vue&type=script&lang=js"
import style0 from "./CMSInfomationForm.vue?vue&type=style&index=0&id=202e2238&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e2238",
  null
  
)

export default component.exports